<script>
import { FormatPercentSalesKpi } from "../../utils";
export default {
  name: "HyperlinkKpiTechnicalSupport",
  functional: true,
  props: {
    row: Object,
    column: String,
    mes: Number,
    openDetail: Function,
    getProductSelected: Function,
    getServiceTypeSelected: Function
  },
  render: function (createElement, context) {
    const val = Number(context.props.row[context.props.column]);
    let classs = "red";

    if (val <= 70) {
      classs = "red";
    } else if (val >= 95) {
      classs = "green";
    } else if (val >= 80 && val <= 95) {
      classs = "golden";
    }

    const MothValue = function (val) {
      // if (val > 0) {
      return FormatPercentSalesKpi(val);
      // } else {
      //   return "";
      // }
    };

    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#",
          class: classs
        },
        on: {
          click: () => {
            const {
              mes,
              row,
              openDetail,
              getProductSelected,
              getServiceTypeSelected
            } = context.props;
            row.currentProductId = getProductSelected();
            row.currentServiceTypeId = getServiceTypeSelected();
            openDetail(mes, row);
          }
        }
      },
      MothValue(val)
    );
  }
};
</script>
<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
</style>
